const GET_TAX_RATE_OPTIONS = 'webservice/get-tax-rate';
const GET_COMPANY_INFO = 'webservice/get-company-info';
const VALIDATE_VOUCHER = 'validate-voucher';
const SAVE_NEW_TAX_RATE = 'settings/product/add-tax-rate-in-product';

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

module.exports = {
    getTaxRateOptions: function (service_id) {
        return window.axios.get(GET_TAX_RATE_OPTIONS,{params:
                    {
                        service_id: service_id
                    }
                });
    },
    getCompanyInformation: function () {
        return window.axios.get(GET_COMPANY_INFO);
    },
    validateVoucher: function (data) {
        let form = new FormData();
        buildFormData(form, data);
        return window.axios.post(VALIDATE_VOUCHER, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    storeNewTaxRate: function (name,value) {
        let form = new FormData();
        buildFormData(form, {
            tax_rate_name:name,
            tax_rate_value:value
        });
        return window.axios.post(SAVE_NEW_TAX_RATE,form);
    }
};  
